"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.barSchemaValidator = exports.barSchemaAdvancedOptsSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const hexadecimalColorRegex = new RegExp(/^#([0-9a-f]{6}|[0-9a-f]{3})$/i);
exports.barSchemaAdvancedOptsSchema = zod_1.z
    .object({
    coloring: zod_1.z
        .array(zod_1.z.object({
        from: zod_1.z.number(),
        to: zod_1.z.number(),
        color: zod_1.z.string().regex(hexadecimalColorRegex),
    }))
        .optional(),
})
    .optional();
exports.barSchemaValidator = zod_1.z.intersection(common_1.commonTypeSchemaValidator, zod_1.z.object({
    name: zod_1.z.string().min(1).optional(),
    goal_name: zod_1.z.string(),
    goal_value: zod_1.z.string(),
    goal_achievement: zod_1.z.string(),
    filter: common_1.widgetFilterValidator.optional(),
    advanced_opts: exports.barSchemaAdvancedOptsSchema,
}));
